import { useGetAllCoursesByTrainerId } from "../../../assets/nodeApi/getApi/getAdminApi";

export const useCourseOptions = (trainerId) => {
    const { data: courseList, isLoading: isCoursesLoading } =
    useGetAllCoursesByTrainerId(trainerId);

    const allCourses = courseList?.data?.map((item, index) => ({
        id: item?.id,
        sr_no: index + 1,
        label: item?.title,
        value: item?.title,
        ...item,
    })) || [];

    const onlineCourses = allCourses.filter((c) => c.online === 1);
    const offlineCourses = allCourses.filter((c) => c.online === 0);

    return {
        AllCourses: {
            onlineOptions: onlineCourses,
            offlineOptions: offlineCourses,
            isLoading: isCoursesLoading,
        },
    };
};
